import { Money } from '@app/currency';
import type { LegacyProduct } from '@app/types';

type PricelineDataProps = (
  product: Nullable<LegacyProduct>,
  t: any,
  currency: Nullable<string>,
  browsePageSelector?: string,
  givenLocale?: string,
  includeStrikethroughAmount?: boolean,
) => {
  label: string;
  amount: string;
  strikethroughAmount?: string;
};

const getPricelineData: PricelineDataProps = (
  product,
  t,
  currency,
  browsePageSelector,
  givenLocale,
  includeStrikethroughAmount = false,
) => ({
  label: t(
    browsePageSelector === 'highestBid'
      ? 'pdp_highest_bid_label'
      : 'pdp_lowest_ask_label',
  ),
  amount: Money.getDollars(
    getPricelinePrice(product, browsePageSelector),
    true,
    true,
    currency,
    givenLocale,
  ),
  ...(includeStrikethroughAmount && {
    strikethroughAmount: Money.getDollars(
      product?.market?.statistics?.last90Days?.averagePrice,
      true,
      true,
      currency,
      givenLocale,
    ),
  }),
});

const getPricelinePrice = (product, browsePageSelector) => {
  if (browsePageSelector === 'highestBid') {
    return product?.market?.highestBid;
  }

  if (product?.market?.state?.lowestAsk?.amount) {
    return product?.market?.state?.lowestAsk?.amount;
  }

  return product?.market?.lowestAsk ?? product?.market?.bidAskData?.lowestAsk;
};

export default getPricelineData;
